import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=2059f87b&scoped=true&"
import script from "./AreaChart.vue?vue&type=script&lang=js&"
export * from "./AreaChart.vue?vue&type=script&lang=js&"
import style0 from "./AreaChart.vue?vue&type=style&index=0&id=2059f87b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059f87b",
  null
  
)

export default component.exports